export default __webpack_public_path__ + "static/media/KZ.M.08.2030.9864c3f6.svg";